import { TFunction } from 'i18next';

export const getProductCategoryOptions = (t: TFunction) => [
  { value: '1', label: t('product.1', 'Agriculture') },
  { value: '12', label: t('product.12', 'Camp Management and Coordination') },
  { value: '16', label: t('product.16', 'Education') },
  { value: '34', label: t('product.34', 'Early Recovery') },
  { value: '38', label: t('product.38', 'Electronics / Telecommunications') },
  { value: '57', label: t('product.57', 'Food (Nutrition and Food Security)') },
  { value: '79', label: t('product.79', 'Health') },
  { value: '119', label: t('product.119', 'Logistics') },
  { value: '168', label: t('product.168', 'Protection') },
  { value: '172', label: t('product.172', 'Shelter') },
  { value: '225', label: t('product.225', 'WASH') },
  { value: '290', label: t('product.290', 'Fuels and Oils') },
  { value: '309', label: t('product.309', 'Operational Support') },
  { value: '310', label: t('product.310', 'Construction') },
  { value: '311', label: t('product.311', 'Telecommunications') },
  { value: '312', label: t('product.312', 'Nutrition') },
  { value: '313', label: t('product.313', 'General Program') },
  { value: '314', label: t('product.314', 'General Operations') },
  { value: '315', label: t('product.315', 'Food Security') },
  { value: '316', label: t('product.316', 'CCCM') }
];

export const getInventoryUnitOptions = (t: TFunction) => [
  { value: '28', label: t('productLtu.28', 'Bulk (kg)') },
  { value: '29', label: t('productLtu.29', 'Each') },
  { value: '30', label: t('productLtu.30', 'Litre') },
  { value: '31', label: t('productLtu.31', 'Pair') },
  { value: '32', label: t('productLtu.32', 'Part') }
];

export const getHandlingUnitOptions = (t: TFunction) => [
  { value: '11', label: t('bundleType.11', 'Bag/Sack') },
  { value: '12', label: t('bundleType.12', 'Bale/Bundle') },
  { value: '13', label: t('bundleType.13', 'Box/Carton') },
  { value: '14', label: t('bundleType.14', 'Crate') },
  { value: '15', label: t('bundleType.15', 'Drum/Barrel') },
  { value: '16', label: t('bundleType.16', 'Kit/Set') },
  { value: '18', label: t('bundleType.18', 'None/Loose') },
  { value: '17', label: t('bundleType.17', 'Roll') }
];
